import {
  Typography,
  Card,
  CardContent,
  Chip,
  Box,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const SubscriptionCard = ({ isSelected, onSelect, planData }) => {
  const {
    name,
    pricing,
    billingCycle,
    features,
    isPopular,
    color,
    badge,
    newPrice,
    hasTrial,
    trialDays,
  } = planData;

  return (
    <Card
      className={`subscription-card cursor transition-all rounded-4 d-flex flex-column h-100 position-relative ${
        isSelected ? "selected shadow-lg" : "border-light"
      }`}
      onClick={() => onSelect(planData)}
      sx={{
        transform: isSelected ? "scale(1.02)" : "scale(1)",
        transition: "all 0.3s ease",
      }}
    >
      {isPopular && (
        <Chip
          label={badge || "Popular"}
          color="warning"
          size="small"
          sx={{
            position: "absolute",
            top: "12px",
            left: "50%",
            transform: "translateX(-50%)",
            fontWeight: 600,
            fontSize: "0.75rem",
            px: 2,
            py: 0.5,
          }}
        />
      )}
      {hasTrial && trialDays && (
        <Chip
          label={`${trialDays} Days Trial`}
          size="small"
          sx={{
            position: "absolute",
            transform: "rotateZ(-30deg) translateX(-50%) translateY(-50%)",
            left: 45,
            top: -15,
            fontWeight: 600,
            fontSize: "1rem",
            px: 6,
            py: 1,
            backgroundColor: "var(--lightOrangeColor)",
            color: "#fff",
            height: 30,
            borderRadius: 0,
          }}
        />
      )}

      <CardContent sx={{ p: 4, pt: "3rem", textAlign: "center", flex: 1 }}>
        <Typography
          variant="h4"
          component="h3"
          className="text-capitalize"
          sx={{
            fontWeight: "bold",
            mb: 2,
            color: color,
          }}
        >
          {name}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <Typography
            variant="h4"
            component="span"
            sx={{
              fontWeight: "500",
              mb: 0,
            }}
          >
            {pricing.symbol}
            <span
              className={`${newPrice ? "text-decoration-line-through" : ""}`}
            >
              {pricing.amount}
            </span>
            <span className="fs-4" style={{ color: "var(--lightOrangeColor)" }}>
              {newPrice}
            </span>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            / {billingCycle}
          </Typography>
        </Box>

        <Box sx={{ mb: 4, textAlign: "left" }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: "semibold", mb: 2, textAlign: "center" }}
          >
            Features:
          </Typography>
          <List dense>
            {features.map((feature, index) => (
              <ListItem key={index} sx={{ py: 0.5, px: 0 }}>
                <ListItemIcon sx={{ minWidth: 24, mr: 1 }}>
                  <CheckCircleIcon
                    sx={{ color: "success.main", fontSize: 16 }}
                  />
                </ListItemIcon>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "0.9rem", lineHeight: 1.4 }}
                >
                  {feature.description}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
};
